// extracted by mini-css-extract-plugin
module.exports = {"card":"CardImage_card__1ThBL","grid":"CardImage_grid__1l_xI","wrapper":"CardImage_wrapper__3ZrBV","photo":"CardImage_photo__1jo9v","list":"CardImage_list__2jsld"};